import { render, staticRenderFns } from "./optionalfees.vue?vue&type=template&id=9a9c4fa4&"
import script from "./optionalfees.vue?vue&type=script&lang=js&"
export * from "./optionalfees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports